var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.isAdmin ? "box" : "",
      style: _vm.isAdmin
        ? "background-color:hsl(0, 0%, 96%)"
        : "background-color: white"
    },
    [
      _c("section", [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.suite.name,
                  expression: "suite.name"
                }
              ],
              staticClass: "input is-medium",
              attrs: { type: "text" },
              domProps: { value: _vm.suite.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.suite, "name", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-2" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.suite.name,
                    expression: "suite.name"
                  }
                ],
                staticClass: "field"
              },
              [
                _c(
                  "label",
                  { staticClass: "image is-square show-icon-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "company-logo",
                      attrs: { src: _vm.fixHttpProtocol(_vm.suite.logo_path) }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "newLogo",
                      staticStyle: { display: "none" },
                      attrs: { type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.uploadLogo(
                            _vm.$refs.newLogo.files[0],
                            _vm.suite
                          )
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "field" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.suite.description,
                    expression: "suite.description"
                  }
                ],
                staticClass: "textarea",
                attrs: { placeholder: "Enter suite description" },
                domProps: { value: _vm.suite.description },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.suite, "description", $event.target.value)
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.isAdmin
          ? _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("\n            Add Contacts\n            "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-pulled-right",
                        class: { "is-loading": _vm.spinnerForResync },
                        attrs: { title: "Re-sync Contacts" },
                        on: {
                          click: function($event) {
                            return _vm.syncContacts()
                          }
                        }
                      },
                      [_vm._m(1)]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.companyContacts,
                          multiple: true,
                          "close-on-select": false,
                          searchable: true,
                          "hide-selected": true,
                          "track-by": "id",
                          label: "name",
                          "custom-label": _vm.customContactLabel
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "tag",
                              fn: function(props) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "multiselect__tag",
                                      on: {
                                        mousedown: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !props.option.is_primary &&
                                                props.option.email,
                                              expression:
                                                "!props.option.is_primary && props.option.email"
                                            }
                                          ],
                                          attrs: {
                                            title:
                                              "Assign " +
                                              props.option.name +
                                              " as the primary contact."
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon",
                                              on: {
                                                mousedown: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.togglePrimary(
                                                    props.option
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-star"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                props.option.is_primary &&
                                                props.option.email,
                                              expression:
                                                "props.option.is_primary && props.option.email"
                                            }
                                          ],
                                          attrs: {
                                            title:
                                              props.option.name +
                                              " is the primary contact."
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon",
                                              on: {
                                                mousedown: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.togglePrimary(
                                                    props.option
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-star"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !props.option.email != "",
                                              expression:
                                                "!props.option.email != ''"
                                            }
                                          ],
                                          attrs: {
                                            title:
                                              "No Email, " +
                                              props.option.name +
                                              " cant' be assigned primary contact."
                                          }
                                        },
                                        [
                                          _c("span", { staticClass: "icon" }, [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle"
                                            })
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(props.option.name)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "multiselect__tag-icon",
                                        attrs: {
                                          "aria-hidden": "true",
                                          tabindex: "1"
                                        },
                                        on: {
                                          click: function($event) {
                                            return props.remove(props.option)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          134008274
                        ),
                        model: {
                          value: _vm.suite.contacts,
                          callback: function($$v) {
                            _vm.$set(_vm.suite, "contacts", $$v)
                          },
                          expression: "suite.contacts"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin
          ? _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "help column has-text-left" }, [
                _vm._v("\n        Can't find a contact?\n        "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        _vm.maxxIntranetDomain +
                        "/membership/IndividualFormPrivate/edit?companyId=" +
                        this.companyId,
                      target: "_blank"
                    }
                  },
                  [_vm._v("Click here")]
                ),
                _vm._v(
                  "\n        to add it to the database. After it has been added, click the refresh\n        button above to pull the new contact into this list.\n      "
                )
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon icon-right is-small" }, [
      _c("i", { staticClass: "fas fa-pen-square" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-sync-alt" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe88d058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe88d058","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/EditSuite.vue
// module id = null
// module chunks = 